import React, { useRef } from 'react';
import { Container, Button } from '@uncinc/uncinc-react-kitchen-sink';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  LanguageSwitcher,
  NewsletterSignupFooter,
} from '..';

import FooterMenu from '../../implementations/Menu/FooterMenu';
import SocialMenu from '../../implementations/Menu/SocialMenu';
import BasicFooterMenu from '../../implementations/Menu/BasicFooterMenu';

import { setTakeoverCookieAndReload } from '../../helpers';

import './style.scss';
import { APP_OPTIONS, DEFAULT_LANGUAGE } from '../../config/constants';

const Footer = () => {
  const { t } = useTranslation();
  const currentEntityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const currentNodeType = useSelector((state) => state.getIn(['node', currentEntityId, 'type', 0, 'target_id']));
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));
  const isCampaignPage = currentNodeType === 'campaign_page';
  const isHomepageTakeover = currentNodeType === 'home_page_takeover';
  const ref = useRef(null);

  return (
    <footer className="Footer" ref={ref}>
      {(!isCampaignPage && !isHomepageTakeover) && (
        <div className="Footer__top">
          <Container>
            <div className="row">
              {currentLanguage === DEFAULT_LANGUAGE && (
                <div className="col-12 col-md-5">
                  <NewsletterSignupFooter />
                </div>
              )}
              <div className={`col-12 ${currentLanguage === DEFAULT_LANGUAGE ? 'col-md-7 col-lg-6 offset-lg-1' : 'pl-0'}`}>
                <SocialMenu />
              </div>
            </div>
          </Container>
        </div>
      )}

      <div className="Footer__mid">
        <Container>
          {(isCampaignPage || isHomepageTakeover)
            ? <BasicFooterMenu />
            : <FooterMenu />}
        </Container>
      </div>
      <div className="Footer__bottom">
        <Container>
          <div className="row">
            <div className="col-12 col-md-12 col-lg-4 order-lg-2 Button-holder">
              {isHomepageTakeover && (
                <Button onClick={() => setTakeoverCookieAndReload(`/node/${currentEntityId}`)}>
                  {t('general.to_homepage')}
                </Button>
              )}
            </div>
            <div className="col-12 col-md-6 col-lg-4 order-lg-1">
              <LanguageSwitcher />
            </div>

            <div className="col-12 col-md-6 col-lg-4 order-lg-3">
              <div className="Footer__bottom__logos">
                <CoreLink to={APP_OPTIONS.parameters.links.footer.cbfURI}>
                  <div className="Footer__bottom__logos__logo logo--cbf" />
                </CoreLink>
                <CoreLink to={APP_OPTIONS.parameters.links.footer.anbiURI}>
                  <div className="Footer__bottom__logos__logo logo--anbi" />
                </CoreLink>
                <CoreLink to={APP_OPTIONS.parameters.links.footer.postcodeLoterijURI}>
                  <div className="Footer__bottom__logos__logo logo--npl" />
                </CoreLink>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
